import { gql } from "@apollo/client/core";
import { IntegrationProductResource } from "../types";
import { graphQlManager, Product } from "..";

const getIntegrationProductsQuery = gql`
    query GetIntegrationProductsForIds($ids: [String!]!) {
        integrationProducts(ids: $ids) {
            id
            product {
                id
                name
            }
        }
    }
`;

export const getIntegrationProducts = async (ids: string[]): Promise<IntegrationProductResource[]> => {
    const response = await graphQlManager.getShadowGraphqlClient().query<{ integrationProducts: { id: string, product: Product }[] }>({
        query: getIntegrationProductsQuery,
        variables: {
            ids,
        },
    })
    return response.data.integrationProducts;
};